import React from 'react'
import { Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const PageHeader = (props) => {
  const breakpoints = useBreakpoint()

  return (
    <Typography
      {...props}
      variant={breakpoints.xl ? 'Header-60' : breakpoints.fb ? 'Header-50' : 'Header-40'}
      component={'h1'}
    >
      {props.children}
    </Typography>
  )
}

PageHeader.propTypes = {
  props: PropTypes.object,
  children: PropTypes.node,
}

export default PageHeader
